import { useContext } from 'react';
import Image from 'next/image';
import * as Styles from './styles';
import { getImageBasePath } from 'utils/generics';
import { MPosContext } from 'utils/context';

function PlansHeader() {
    const { planDetails } = useContext(MPosContext);

    const { device } = planDetails;

    return (
        <>
            <Styles.HeaderWrapper>
                <Styles.PhoneIconFlex>
                    <Image
                        width={'11px'}
                        height={'16px'}
                        alt={''}
                        src={getImageBasePath('/icons/phone.svg')}
                    />
                </Styles.PhoneIconFlex>
                <Styles.ModelNameFlex>
                    <Styles.ModelName>{device.name}</Styles.ModelName>
                </Styles.ModelNameFlex>
            </Styles.HeaderWrapper>
            <Styles.Hr />
        </>
    );
}

export default PlansHeader;
